<template>
  <q-page>
    <div class="row">
      <div class="col-12">
        <q-card>
          <q-card-section class="bg-white text-accent">
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">
                Organizations
              </div>
              <q-btn
                v-if="['superAdmin', 'appAdmin'].includes(currentUserData.role)"
                class="q-ml-md"
                color="primary"
                text-color="white"
                no-caps
                @click="newDialog = true"
              >
                <q-icon
                  name="mdi-plus-circle"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Add
              </q-btn>
              <q-btn
                class="q-ml-md"
                color="secondary"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-refresh"
                :loading="organizationsLoading"
                @click="$store.dispatch('organizations/loadAll')"
              >
              </q-btn>
              <q-space />
              <q-input
                style="max-width: 70%"
                filled
                v-model="search"
                debounce="200"
                label="Search"
                clearable
                dense
              >
                <template #prepend>
                  <q-icon name="mdi-magnify"> </q-icon>
                </template>
              </q-input>
            </div>
          </q-card-section>

          <q-separator />
          <q-card-section class="q-pa-none">
            <div v-if="organizations">
              <div class="row">
                <!-- <div class="col-12 my-0 py-0 pl-6">
                  *Double click row to open
                </div> -->

                <div
                  class="col-12 mt-0 pt-0"
                  style="height: calc(100vh - 160px) !important"
                >
                  <datatable
                    :filter="search"
                    :flat="true"
                    :data="organizations"
                    :columns="filteredColumns"
                    @rowDoubleClick="handleDoubleClick"
                  >
                  </datatable>
                </div>
              </div>
            </div>
          </q-card-section>
          <!-- <expandedToolbar
            :newButton="true"
            @newButtonClick="newDialog = true"
          /> -->
        </q-card>
      </div>
    </div>
    <q-dialog v-model="newDialog" max-width="600px">
      <q-card v-if="newDialog" tile style="width: 90vw; max-width: 600px">
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">
              New Organization
            </div>
            <q-space />
            <q-btn
              color="accent2"
              round
              flat
              icon="mdi-close"
              @click="
                newDialog = false;
                newFormData = {};
              "
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <organizationForm
            ref="newForm"
            @close="newDialog = false"
            @loadingStateChanged="state => (createLoading = state)"
          />
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="$refs.newForm.create()"
                :loading="createLoading"
                color="primary"
                no-caps
                class="float-right"
              >
                <q-icon
                  name="mdi-plus-circle"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Add
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="viewDetailsDialog" max-width="600px">
      <q-card
        v-if="viewDetailsDialog"
        tile
        style="width: 90vw; max-width: 600px"
      >
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">
              Organization
            </div>
            <q-space />
            <q-btn
              color="accent2"
              round
              flat
              icon="mdi-close"
              @click="viewDetailsDialog = false"
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <organizationForm
            ref="editForm"
            :data="viewFormData"
            @close="viewDetailsDialog = false"
            @loadingStateChanged="state => (saveLoading = state)"
          />
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="$refs.editForm.save()"
                :loading="saveLoading"
                color="primary"
                no-caps
                class="float-right"
              >
                <q-icon
                  name="mdi-content-save"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Save
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import datatable from "@/components/datatable/datatable.vue";
import organizationForm from "@/components/organizations/organizationForm.vue";
import moment from "moment";

// import { Notify } from "quasar";

export default {
  components: {
    datatable,
    organizationForm
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
      organizations: "organizations/list",
      organizationsLoading: "organizations/listLoading"
    }),
    filteredColumns: function() {
      return this.columns.filter(
        c => !c.roles || c.roles.includes(this.currentUserData.role)
      );
    }
  },
  data: () => ({
    // data-table
    columns: [
      {
        name: "id",
        label: "ID",
        align: "left",
        field: "id",
        sortable: true
      },
      {
        name: "name",
        label: "Name",
        align: "left",
        field: "name",
        sortable: true
      },
      {
        name: "applications_name",
        label: "Application",
        align: "left",
        field: "applications_name",
        sortable: true,
        roles: ["superAdmin"]
      },
      {
        name: "devices",
        label: "Devices",
        align: "left",
        field: "devices",
        sortable: true
      },
      {
        name: "deployments",
        label: "Active Deployments",
        align: "left",
        field: "deployments",

        sortable: true
      },
      {
        name: "created_at",
        label: "Created At",
        align: "left",
        field: "created_at",
        format: val =>
          val != null
            ? moment
                .utc(val)
                .local()
                .format("DD-MMM, YYYY h:mma")
            : "",
        sortable: true
      },
      {
        name: "updated_at",
        label: "Updated At",
        align: "left",
        field: "updated_at",
        format: val =>
          val != null
            ? moment
                .utc(val)
                .local()
                .format("DD-MMM, YYYY h:mma")
            : "",
        sortable: true
      }
    ],
    search: "",

    createLoading: false,

    newDialog: false,

    // View and Edit
    viewFormData: {},
    saveLoading: false,
    viewDetailsDialog: false
  }),
  beforeCreate() {
    this.$store.dispatch("organizations/loadAll");
  },
  mounted() {},
  methods: {
    handleDoubleClick(row) {
      if (
        ["superAdmin", "appAdmin"].includes(this.currentUserData.role) ||
        this.currentUserData.organizationsAdminOf.split(",").includes(row.id)
      ) {
        this.viewFormData = row;
        this.viewDetailsDialog = true;
      }
    }
  }
};
</script>

<style scoped>
#depthCard:hover {
  background: #5cb3ff;
  color: white;
}
</style>
